var React = require('react');

function Road (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.39844 10.8002L3.99844 1.2002M9.19844 1.2002L11.7984 10.8002M6.59844 3.25734V1.88591M6.59844 6.68591V5.31448M6.59844 10.1145V8.74305","stroke":"#666666","strokeWidth":"1.33","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Road.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = Road;

Road.default = Road;
